const LAT_LNG_SEPARATOR = ',';

// set fields we want for response (to reduce api costs in case)
export const GMAPS_REQUESTED_FIELDS = ['location'];
// set type we want for response because by default it's cities only so cannot find val thorens etc..
// MAX: 5, cf: https://developers.google.com/maps/documentation/javascript/legacy/supported_types?hl=fr
export const GMAPS_REQUESTED_TYPES = ['locality', 'sublocality', 'administrative_area_level_3', 'colloquial_area', 'point_of_interest'];

export const containsLatLng = strValue =>
  strValue != null && strValue.toString().includes(LAT_LNG_SEPARATOR) && isValidLatLng(adaptPlaceForFrontEnd(strValue));

const isValidLatLng = latLngObject => {
  if (latLngObject == null || isNaN(latLngObject.lat) || isNaN(latLngObject.lng)) {
    return false;
  }
  return true;
};

export const adaptPlaceForBackend = place => {
  if (place == null) return '';

  if (place.location != null) {
    return place.location.lat() + LAT_LNG_SEPARATOR + place.location.lng();
  }

  if (place.lat != null && place.lng != null) {
    return place.lat + LAT_LNG_SEPARATOR + place.lng;
  }

  return '';
};

export const adaptPlaceForFrontEnd = backendValue => {
  const splitted = backendValue ? backendValue.split(LAT_LNG_SEPARATOR) : [];
  if (splitted.length != 2) return null;
  return { lat: parseFloat(splitted[0]), lng: parseFloat(splitted[1]) };
};

// this might need changes later as the geocoding api evolves
// the new places api has a different naming of the properties
export const formatGeocodingOutput = geocodingResponse => {
  const locality = geocodingResponse.address_components?.find(c => c.types.includes('locality'));
  if (locality?.long_name) {
    return locality.long_name;
  }
  return geocodingResponse.formatted_address || null;
};
